// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body.dialog-open {\n  overflow: hidden;\n}", "",{"version":3,"sources":["webpack://src/components/custom-dialog/dialog.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":["body.dialog-open {\r\n  overflow: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
